import _regeneratorRuntime from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/github/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { ExternalInteractorBase } from "../../../Core/Utils/ExternalInteractorBase";
export var Pauser = /*#__PURE__*/function (_ExternalInteractorBa) {
  _inherits(Pauser, _ExternalInteractorBa);
  var _super = _createSuper(Pauser);
  function Pauser(container) {
    var _this;
    _classCallCheck(this, Pauser);
    _this = _super.call(this, container);
    _this.handleClickMode = function (mode) {
      if (mode !== "pause") {
        return;
      }
      var container = _this.container;
      if (container.getAnimationStatus()) {
        container.pause();
      } else {
        container.play();
      }
    };
    return _this;
  }
  _createClass(Pauser, [{
    key: "isEnabled",
    value: function isEnabled() {
      return true;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function () {
      var _interact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function interact() {
        return _interact.apply(this, arguments);
      }
      return interact;
    }()
  }]);
  return Pauser;
}(ExternalInteractorBase);